{
  "home": {
    "heroStop": "ARRÊTONS LE HUMAN SAFARI",
    "heroSave": "SAUVONS KHERSON",
    "heroTitle1": "Les civils",
    "heroTitle2": "ne sont pas des cibles",
    "heroDate": "13, 14 décembre",
    "worldwideRally": "Rassemblement Mondial",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Depuis l'été 2024, les forces russes utilisent de petits drones afin de pourchasser, tuer et terroriser les civils dans les rues de Kherson et d'autres villes proches du front en Ukraine. <bold>Ce safari humain doit cesser. VOUS pouvez aider.</bold> Rejoignez des milliers de personnes dans le monde pour exiger l'arrêt de ce crime de guerre.",
    "seeGallery": "Voir les affiches du monde entier",
    "comingSoon": "Lieux bientôt disponibles",
    "december": "décembre",
    "dec": "déc.",
    "october": "octobre",
    "oct": "oct.",
    "september": "septembre",
    "sep": "sept.",
    "schedule9": "9",
    "schedule10": "10",
    "schedule11": "11",
    "schedule12": "12",
    "schedule13": "13",
    "schedule14": "14",
    "schedule16": "16",
    "schedule18": "18",
    "schedule20": "20",
    "schedule1": "1er",
    "schedule2": "2",
    "schedule3": "3",
    "schedule4": "4",
    "schedule5": "5",
    "schedule25": "25",
    "schedule26": "26",
    "schedule27": "27",
    "schedule28": "28",
    "schedule29": "29",
    "schedule30": "30",
    "schedule31": "31",
    "scheduleTBC": "Date à confirmer...",
    "recommendationsTitle": "Recommandations de la Commission de l'ONU",
    "recommendationsRussia": "La Commission recommande à la Fédération de Russie de:",
    "rusRec1": "(a) Mettre immédiatement fin aux attaques de drones ciblant les civils et les biens civils",
    "rusRec2": "(b) Cesser immédiatement tous les actes qui répandent la terreur parmi la population civile",
    "rusRec3": "(c) Veiller à ce que tous les auteurs impliqués dans les attaques de drones contre des civils soient tenus responsables",
    "recommendationsUNStates": "La Commission recommande aux autres États ainsi qu'aux organisations régionales et internationales :",
    "statesRec1": "(a) D’apporter un soutien financier et technique au gouvernement ukrainien et aux organisations de la société civile pour fournir une aide complète aux victimes et à leurs familles ;",
    "statesRec2": "(b) Pour les États tiers accueillant des personnes déplacées des territoires temporairement occupés, d’entreprendre les efforts nécessaires pour soutenir ces personnes avec les services consulaires ukrainiens."
  },
  "resources": {
    "title": "Ressources clés",
    "linkLibraryTitle": "Bibliothèque de liens",
    "linkLibraryDesc": "200 articles, rapports, interviews, témoignages directs et reportagese",
    "humanSafariMapTitle": "Carte du Human Safari de Tochnyi",
    "humanSafariMapDesc": "Une carte interactive des attaques du Human Safari à Kherson, compilée à partir de rapports en source ouverte des autorités locales et de vidéos d'attaques géolocalisées par l'équipe de Tochnyi.",
    "truthHoundsTitle": "Rapport Truth Hounds",
    "truthHoundsDesc": "Killzone : comment les drones russes dévastent la rive droite du Dnipro",
    "hrwTitle": "Rapport Human Rights Watch sur les attaques de drones à Kherson",
    "hrwDesc": "Rapport HRW",
    "unReportsTitle": "Rapports du Conseil des Droits de l’Homme de l’ONU",
    "report1": "Rapport ONU #1",
    "report3": "Rapport ONU #3",
    "guidelines": "Directives de l’ONU",
    "wikipediaTitle": "Wikipédia",
    "english": "Anglais",
    "french": "Français",
    "documentaryTitle": "Documentaire",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13 - 14 déc.",
    "eyewitnesses": "Témoins",
    "rallies": "Photos",
    "help": "Kherson désoccupée",
    "leftBank": "Kherson occupée",
    "action": "déc. '25",
    "oleshky": "manif mondiale - Oleshky",
    "menu": "Menu"
  },
  "leftBank": {
    "pageTitle": "Siège par drones",
    "para1": "Une grave urgence humanitaire touche 6 000 civils pris au piège d'un siège par drones dans les villes occupées d'Oleshky, Hola Prystan, Stara Zburivka et Nova Zburivka - région occupée de Kherson. À Oleshky, entre 1 200 et 2 000. La puissance occupante est tenue de leur venir en aide - au lieu de cela, les forces russes les utilisent comme boucliers humains, pour se cacher derrière cette population tout en menant des attaques de safari humain sur la rive opposée. Les autorités ukrainiennes et les acteurs humanitaires signalent une obstruction systématique de l'évacuation et de l'accès humanitaire.",
    "para2": "Les civils manquent de nourriture, d'eau, de soins médicaux, de médicaments, d'électricité, de gaz et de moyens de communication. Les routes sont fortement minées et l'activité des drones restreint les déplacements. Aucun véhicule n'a pu entrer ni sortir depuis le 26 mai. Les réserves de carburant et de nourriture sont presque épuisées.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Vidéo : « Kherson and Oleshky: Witnessing Genocide » (12 min)",
    "meidasArticle": "Article : « The Kherson Region: How Russia Uses Civilians as a Tool of War » (5 min de lecture)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Article : « Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate » (7 min de lecture)",
    "tellPost": "et parlez du Siège par drones autour de vous",
    "callToHelp": "VOUS pouvez aider. Voici comment",
    "donateIntro": "Ces initiatives apportent une aide ciblée et à fort impact directement aux personnes qui ont fui Oleshky ou, lorsque c’est possible, qui y sont encore piégées.",
    "signTitle": "Signez",
    "signSub": "pétitions",
    "petitionBy": "par {{name}}",
    "petitions": {
      "euParliament": "Parlement européen – Pétition n° 1439/2026 demandant l’ouverture d’un corridor humanitaire d’évacuation pour les civils pris au piège du siège à Oleshky (Ukraine), occupée par la Russie",
      "ukParliament": "Parlement britannique – Mettre en place un corridor d’aide humanitaire dirigé par le Royaume-Uni vers Oleshky, en Ukraine"
    },
    "publicActionLead": "Braquez les projecteurs sur le siège par drones là où vous êtes.",
    "organiseAction": "Organisez une action.",
    "policyBody": "Les autorités ukrainiennes mènent des consultations avec le Comité international de la Croix-Rouge en vue d'établir un couloir humanitaire d'évacuation depuis les localités occupées de la région de Kherson et de garantir un accès humanitaire pour la nourriture, l'eau, les médicaments, le carburant et l'assistance médicale. Début juin, aucun couloir d'évacuation fonctionnel ni mécanisme durable d'accès humanitaire n'est en place.",
    "documentaryTitle": "Oleshky, court documentaire",
    "downloadTitle": "Télécharger",
    "downloadSub": "visuels"
  },
  "footer": {
    "addCityText": "Pour ajouter votre ville, envoyez un e-mail à :",
    "organiseText": "Ajoutez votre manifestation - contactez-nous :",
    "contact": "Contact :"
  },
  "byCountry": "voir par pays",
  "byDate": "voir par date",
  "countries": {
    "australia": "Australie",
    "austria": "Autriche",
    "bulgaria": "Bulgarie",
    "canada": "Canada",
    "czechia": "Tchéquie",
    "denmark": "Danemark",
    "estonia": "Estonie",
    "finland": "Finlande",
    "france": "France",
    "georgia": "Géorgie",
    "germany": "Allemagne",
    "hungary": "Hongrie",
    "italy": "Italie",
    "japan": "Japon",
    "mexico": "Mexique",
    "netherlands": "Pays-Bas",
    "norway": "Norvège",
    "poland": "Pologne",
    "romania": "Roumanie",
    "spain": "Espagne",
    "sweden": "Suède",
    "southAfrica": "Afrique du Sud",
    "ukraine": "Ukraine",
    "unitedKingdom": "Royaume-Uni",
    "usa": "États-Unis",
    "ireland": "Irlande",
    "belgium": "Belgique"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Espagne",
      "time": "Alicante - Espagne, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelone",
      "country": "Espagne",
      "time": "Barcelone - Espagne, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "États-Unis",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlin",
      "country": "Allemagne",
      "time": "Berlin - Allemagne, 12:00",
      "location": "Tempelhofer Feld, entrée Leinstr./coin de Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "États-Unis",
      "time": "Bettendorf - USA, 17:30 - Projection",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Projection",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Royaume-Uni",
      "time": "Birmingham - Royaume-Uni, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Allemagne",
      "time": "Bonn - Allemagne, 14:00 - 16:00",
      "location": "Poststraße, devant la gare centrale",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Brême",
      "country": "Allemagne",
      "time": "Brême - Allemagne, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Hongrie",
      "time": "Budapest - Hongrie, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "États-Unis",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley Building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Roumanie",
      "time": "Constanța - Roumanie, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Copenhague",
      "country": "Danemark",
      "time": "Copenhague - Danemark, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "États-Unis",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "États-Unis",
      "time": "Denver - USA, 12:00",
      "location": "Colorado Capitol Building, marches ouest",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Édimbourg",
      "country": "Royaume-Uni",
      "time": "Édimbourg - Royaume-Uni, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "États-Unis",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hambourg",
      "country": "Allemagne",
      "time": "Hambourg - Allemagne, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "États-Unis",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finlande",
      "time": "Helsinki - Finlande, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japon",
      "time": "Izumo - Japon, 13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japon",
      "time": "Izumo - Japon",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops",
      "country": "Canada",
      "time": "Kamloops - Canada, 15:00 - 16:00",
      "location": "Hôtel de ville",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ukraine",
      "time": "Kyiv - Ukraine, 17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Allemagne",
      "time": "Leipzig - Allemagne, 12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "Londres",
      "country": "Royaume-Uni",
      "time": "Londres - Royaume-Uni, 18:30 - Projection",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Projection",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "États-Unis",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "Espagne",
      "time": "Málaga - Espagne, 18:00 - Projection",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - Projection",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Royaume-Uni",
      "time": "Manchester - Royaume-Uni, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Mexico City",
      "country": "Mexique",
      "time": "Mexico City - Mexique, 11:00",
      "location": "Alameda Central. Fontaine \"Amériques\" (entre Hemiciclo Juárez et Kiosque)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Milan",
      "country": "Italie",
      "time": "Milan - Italie, 15:00",
      "location": "Cathédrale de Milan",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Munich",
      "country": "Allemagne",
      "time": "Munich - Allemagne, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "New York",
      "country": "États-Unis",
      "time": "New York - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "New York",
      "country": "États-Unis",
      "time": "New York - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Allemagne",
      "time": "Nienburg (Weser) - Allemagne, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norvège",
      "time": "Oslo - Norvège, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Suède",
      "time": "Östersund - Suède, 11:00 - 14:00",
      "location": "Stortorget (place principale)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:30 - 13:30",
      "location": "Ambassade de russie",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:00 - 13:00",
      "location": "Ambassade des États-Unis",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Paris",
      "country": "France",
      "time": "Paris - France, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (marche)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgarie",
      "time": "Plovdiv - Bulgarie, 16:00 - 17:00",
      "location": "près de la Maison Levski",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Prague",
      "country": "Tchéquie",
      "time": "Prague - Tchéquie, 14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Afrique du Sud",
      "time": "Rosendal - Afrique du Sud, 11:00",
      "location": "Bureaux du South African Police Service",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Tenerife",
      "country": "Espagne",
      "time": "San Andrés, Tenerife - Espagne, 13:00",
      "location": "--",
      "cleanTime": "13.00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "États-Unis",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "États-Unis",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Allemagne",
      "time": "Schwerin - Allemagne, 19:00 - Projection",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Projection",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "États-Unis",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgarie",
      "time": "Sveti Vlas - Bulgarie, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australie",
      "time": "Sydney - Australie, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallinn",
      "country": "Estonie",
      "time": "Tallinn - Estonie, 15:00 - Projection et Rassemblement",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Projection et Rassemblement",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Espagne",
      "time": "Tarragona - Espagne, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "La Haye",
      "country": "Pays-Bas",
      "time": "La Haye - Pays-Bas, 13:00 - 15:00",
      "location": "Devant le Palais de la Paix / CPI",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tbilissi",
      "country": "Géorgie",
      "time": "Tbilissi - Géorgie, 21:00",
      "location": "Tbilissi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Suède",
      "time": "Tranås - Suède, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Vienne",
      "country": "Autriche",
      "time": "Vienne - Autriche, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (à côté de la cathédrale Saint-Étienne)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington, D.C.",
      "country": "États-Unis",
      "time": "Washington, D.C. - USA, 12:30 - 13:30",
      "location": "La Maison Blanche",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Pologne",
      "time": "Wrocław - Pologne, 13:00",
      "location": "Place de la Liberté (direction People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Organisez ! Pour ajouter votre ville, envoyez un e-mail à :",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Partager sur {{platform}}",
    "website": "Site web",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, journaliste et cinéaste, a organisé le rassemblement mondial et a réalisé le documentaire Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Protection des civils pour les rues de Kherson — protéger les civils des attaques de drones.",
      "foodDesc": "Aide alimentaire.",
      "foodNote": "Lors de votre don, indiquez « Food for Cherson » en référence."
    },
    "ahs": {
      "name": "Projet Anti Human Safari",
      "desc": "Détecteurs de drones et gilets de protection pour les bénévoles et les services d'urgence à Kherson."
    },
    "pageTitle": "Arrêtez le Human Safari",
    "sectionIntro": "Depuis l'été 2024, l'armée russe utilise de petits drones pour chasser, tuer et terroriser des civils dans les rues de Kherson et d'autres villes de première ligne en Ukraine.",
    "sectionIntro2": "C'est une campagne de meurtres systématique et délibérée : les opérateurs de drones russes publient ouvertement les images de leurs victimes sur des chaînes Telegram pour s'en vanter. En mai 2025, l'ONU a reconnu le Human Safari comme un crime de guerre en cours.",
    "sectionIntro3": "Trop peu est fait. Le Human Safari doit cesser.",
    "sectionIntroBold": "VOUS pouvez aider. Voici comment",
    "step2Title": "Organisez",
    "step3Title": "Parlez-en autour de vous",
    "step3Para": "Utilisez les hashtags",
    "step3ParaPost": "et parlez du Human Safari autour de vous",
    "instagram": "Instagram",
    "step2Bullet1": "une projection de film",
    "step2Bullet2": "une action publique",
    "step2Bullet3": "une couverture médiatique",
    "publicActionLead": "Braquez les projecteurs sur le safari humain là où vous êtes.",
    "reachOutPre": "Vous pouvez",
    "reachOut": "nous contacter",
    "reachOutPost": "pour des idées et des ressources",
    "newsCoverageLead": "via vos contacts dans les médias. Parlez-leur du safari humain et du risque pour toutes les zones de conflit actuelles et futures.",
    "putInTouchPre": "Vous pouvez aussi",
    "putInTouch": "nous mettre directement en relation",
    "inform": "Informez",
    "informSub": "vous et les autres",
    "policyTitle": "Politique",
    "policyBody": "La proposition de loi LORA (Liability for Operators and Responsible Authorities Act) instaurerait des sanctions tout au long de la chaîne de responsabilité : des opérateurs et commandants russes de drones FPV jusqu'au haut commandement militaire, ainsi que des fabricants et fournisseurs qui permettent la production et le déploiement de drones contre les civils.",
    "policyHelp": "Vous pouvez agir au niveau politique ?",
    "getInTouch": "Contactez-nous",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "donate": "Faire un don",
    "donateIntro": "Ces initiatives apportent une aide ciblée et à fort impact pour protéger directement les civils de Kherson du Human Safari.",
    "shareTitle": "Faites passer le mot",
    "filmScreening": "Organisez une projection du documentaire Kherson Human Safari :",
    "howItStarted": "Comment tout a commencé",
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Aidez-les à financer l’hébergement et les produits de première nécessité des habitants d’Oleshky."
    }
  },
  "action": {
    "intro": "Nous avons commencé avec une manifestation mondiale. Vous pouvez maintenant :",
    "helpLink": "aider ici"
  },
  "accounts": {
    "heading": "Témoignages"
  },
  "media": {
    "close": "Fermer",
    "view": "Voir le média",
    "previous": "Précédent",
    "next": "Suivant",
    "andrushenkoCredit": "Oleksandr Andrushenko, photocorrespondant du média Vgoru",
    "khersonPoliceCredit": "de @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, photojournaliste de Kherson",
    "telegramChannelCredit": "publié par la chaîne Telegram russe du Human Safari « de Marioupol aux Carpates »",
    "fruitSellerDescription": "Un vendeur de fruits poursuivi par un drone à fibre optique",
    "burntCarDescription": "Voiture calcinée à Kherson",
    "bridgeAttackDescription": "Un adolescent tué par un drone FPV sous un pont à Kherson",
    "busAttackDescription": "Une des nombreuses attaques de drones FPV contre les transports publics",
    "fpvDroneDescription": "Drone FPV en chasse pendant le « Human Safari »",
    "antiDroneNetsDescription": "Rue de Kherson recouverte de filets contre les drones du « Human Safari »",
    "firefighterDescription": "Un pompier éteint une voiture après une frappe du « Human Safari », une victime gît derrière"
  },
  "follow": {
    "title": "Suivre",
    "subHumanSafari": "des sources de qualité qui informent depuis Kherson et sur le Human Safari",
    "subDroneSiege": "des sources de qualité qui informent depuis Kherson et sur le siège par drones",
    "localPress": "presse locale en ukrainien",
    "lang": {
      "english": "anglais",
      "german": "allemand",
      "ukrainian": "ukrainien"
    },
    "language": "Langue : {{list}}",
    "languages": "Langues : {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "Journaliste et cinéaste américaine basée à Kherson, collabore avec Byline Times et Euromaidan Press ; réalisatrice du documentaire Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Grand reporter du journal allemand Die Welt ; couvre régulièrement le Human Safari à Kherson."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Publie Kherson Weekly, une chronique continue des attaques de drones russes contre les civils à Kherson et dans les villages alentour."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Plateforme médiatique indépendante de la région de Kherson, sur la vie sous les frappes et sous l'occupation."
    },
    "suspilne": {
      "name": "Suspilne Kherson",
      "desc": "La rédaction de Kherson du diffuseur public ukrainien."
    },
    "most": {
      "name": "MOST",
      "desc": "Agence de presse locale de Kherson, couvrant la ville et la région."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "ARRÊTONS LE SIÈGE PAR DRONES",
      "heroSave": "SAUVONS OLESHKY",
      "worldwideRally": "Manif Mondiale",
      "heroDate": "Octobre",
      "infoText1": "Des milliers de civils sont pris au piège d'un siège par drones à Oleshky, Hola Prystan, Stara Zburivka et Nova Zburivka. Les forces russes s'en servent comme boucliers humains et se cachent derrière eux pour mener des attaques de safari humain par drones sur la rive opposée.",
      "infoText2": "La crise est aiguë : manque de nourriture, d'eau, de soins médicaux, de médicaments, d'électricité, de gaz et de moyens de communication. Les routes sont lourdement minées et les drones entravent tout déplacement. <bold>VOUS pouvez aider. Rejoignez des milliers de personnes dans le monde pour exiger la fin du siège par drones.</bold>",
      "imageAlt": "Un chien affamé parmi des ossements humains dans Oleshky en ruines, sous un ciel rouge rempli de drones, avec les mots Stop Russian Drone Siege",
      "demandsTitle": "Nous demandons :",
      "demand1": "des couloirs humanitaires sûrs et efficaces vers Oleshky et les autres communautés touchées.",
      "demand2": "une aide humanitaire immédiate et une assistance aux victimes des attaques de safari humain.",
      "demand3": "des sanctions appropriées contre les personnes et les chaînes d'approvisionnement responsables d'attaques visant des civils.",
      "demand4": "des mesures pour dissuader l'utilisation de petits drones pour cibler et terroriser systématiquement des civils à Kherson, en Ukraine et ailleurs.",
      "cities": {
        "edinburgh": {
          "city": "Édimbourg",
          "country": "Royaume-Uni",
          "time": "Édimbourg - Royaume-Uni, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Royaume-Uni",
          "time": "Birmingham - Royaume-Uni, 14:00 - 16:00",
          "location": "En face du Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Vienne",
          "country": "Autriche",
          "time": "Vienne - Autriche, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Munich",
          "country": "Allemagne",
          "time": "Munich - Allemagne, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "Royaume-Uni",
          "time": "Manchester - Royaume-Uni, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australie",
          "time": "Sydney - Australie, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Paris",
          "country": "France",
          "time": "Paris - France, 15:30 - 18:30",
          "location": "De l'église Saint-Volodymyr à la place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Paris",
          "country": "France",
          "time": "Paris - France, 18:00",
          "location": "Métro Rambuteau",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "France",
          "time": "Lyon - France, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublin",
          "country": "Irlande",
          "time": "Dublin - Irlande, 13:00",
          "location": "The GPO (poste centrale)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Bruxelles",
          "country": "Belgique",
          "time": "Bruxelles - Belgique, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Bruxelles (rond-point Schuman)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Canada",
          "time": "Ottawa - Canada, 12:30 - 13:30",
          "location": "Ambassade de Russie, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "France",
          "time": "Nantes - France, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Gdańsk",
          "country": "Pologne",
          "time": "Gdańsk - Pologne, 18:30 - 19:30",
          "location": "Długi Targ, à côté de la fontaine de Neptune",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "États-Unis",
          "time": "Chicago - États-Unis, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "États-Unis",
          "time": "Chicago - États-Unis, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "États-Unis",
          "time": "Chicago - États-Unis, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "États-Unis",
          "time": "Chicago - États-Unis, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresde",
          "country": "Allemagne",
          "time": "Dresde - Allemagne, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Malaga",
          "country": "Espagne",
          "time": "Malaga - Espagne, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgarie",
          "time": "Plovdiv - Bulgarie, 17:00",
          "location": "Rue principale (Glavnata), près des escaliers Kamenitza / de l'inscription « Together »",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Hongrie",
          "time": "Budapest - Hongrie, 17:00 - 20:00",
          "location": "Szent István tér (place Saint-Étienne)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hambourg",
          "country": "Allemagne",
          "time": "Hambourg - Allemagne, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, au niveau du ponton 1, 20359 Hambourg",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Allemagne",
          "time": "Kiel - Allemagne, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norvège",
          "time": "Oslo - Norvège",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Allemagne",
          "time": "Leipzig - Allemagne, 17:00 - 18:00",
          "location": "Gare centrale (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "Londres",
          "country": "Royaume-Uni",
          "time": "Londres - Royaume-Uni, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublin",
          "country": "Irlande",
          "time": "Dublin - Irlande, 13:00",
          "location": "The GPO (poste centrale)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublin",
          "country": "Irlande",
          "time": "Dublin - Irlande, 14:00",
          "location": "The GPO (poste centrale)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "France",
          "time": "Nantes - France, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Stop au siège russe par drones",
      "posterNoRoadOut": "Les routes pour entrer et sortir d'Oleshky sont bloquées",
      "posterHumanitarianCatastrophe": "Oleshky. Une catastrophe humanitaire sous l'occupation",
      "seeGallery": "Voir / télécharger les affiches"
    },
    "artBy": "Art : {{name}}",
    "downloadPoster": "Télécharger l'affiche",
    "reel": {
      "download": "Télécharger la vidéo (MP4)"
    },
    "addDemo": {
      "title": "ajoutez votre manifestation",
      "where": "où : ville",
      "contact": "e-mail/numéro",
      "message": "message : qui vous représentez, votre manifestation est confirmée ou en préparation, lien vers l'annonce en ligne, autres détails",
      "submit": "Envoyer",
      "sending": "Envoi…",
      "thanks": "Merci ! Nous vous recontacterons.",
      "error": "Une erreur s'est produite. Veuillez réessayer.",
      "contactInvalid": "Veuillez saisir un e-mail valide ou un numéro de téléphone avec l'indicatif du pays (ex. +33 6 12 34 56 78).",
      "date": "date",
      "time": "heure de début (locale)",
      "whereInvalid": "Veuillez saisir le nom d'une ville, ex. Paris ou Kyiv, Ukraine.",
      "datePlaceholder": "date : jj/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Arrêtons le siège par drones — Sauvons Oleshky",
      "description": "Des drones russes assiègent des milliers de civils à Oleshky, en Ukraine occupée, privés de nourriture, d'eau et de médicaments. Trouvez une manifestation près de chez vous et exigez un passage sûr."
    },
    "leftBank": {
      "title": "Siège par drones d'Oleshky et de la région occupée de Kherson",
      "description": "Des milliers de civils sont pris au piège d'un siège russe par drones à Oleshky, Hola Prystan et dans les villages occupés voisins. Découvrez ce qui se passe et comment aider."
    },
    "help": {
      "title": "Arrêtons le Human Safari — Des drones russes traquent les civils à Kherson",
      "description": "Des drones russes traquent les civils à Kherson, en Ukraine. Découvrez le crime de guerre du Human Safari et comment aider à l'arrêter."
    },
    "action": {
      "title": "Rassemblement mondial de décembre 2025 — Arrêtons le Human Safari",
      "description": "Photos, affiches et lieux du rassemblement mondial de décembre 2025 contre les attaques russes de drones sur les civils à Kherson, en Ukraine."
    },
    "rallies": {
      "title": "Photos des rassemblements — Arrêtons le Human Safari",
      "description": "Photos de rassemblements dans le monde contre les attaques russes de drones sur les civils à Kherson, en Ukraine."
    },
    "resources": {
      "title": "Ressources sur le Human Safari — Rapports, articles et témoignages",
      "description": "Rapports, articles, entretiens et témoignages sur les attaques russes de drones contre les civils à Kherson, en Ukraine."
    },
    "reel": {
      "title": "Sauvons Oleshky — Vidéo des manifestations",
      "description": "Vidéo des manifestations mondiales « Sauvons Oleshky », octobre 2026."
    }
  }
}
